var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpgLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2714_15756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 6.5L15.5 5.5L9.5 25.5L14 27L18.5 24.5L22.5 23L33 12L31.5 6.5Z",
    fill: "#C1FF05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0637 38H0L10.2937 0H29.6262C36.3594 0 40.3724 5.41716 38.5679 12.0807C36.7634 18.7443 29.8147 24.1615 23.0815 24.1615H20.3559L20.1296 24.7634C18.5029 29.0566 14.3552 31.901 9.71738 31.901L8.0637 38ZM11.8774 23.9271H19.5856L21.5625 18.7124C22.1388 17.1943 23.604 16.1876 25.2415 16.1876C27.5308 16.1876 29.8901 14.3445 30.5042 12.0807C31.1182 9.81693 29.7554 7.97393 27.4661 7.97393H16.1974L11.8774 23.9218V23.9271Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2714_15756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpgLog);
export default __webpack_public_path__ + "static/media/ppg_log.771edc897d551c1b9a00707f8a9060bf.svg";
export { ForwardRef as ReactComponent };